<template>
  <div class="rank" v-if="new_rankList">
    <!-- 睡眠得分排行榜 -->
    <div class="rankList">
      <div class="rListTop">
        <div class="rListTopTit">睡眠得分排行榜</div>
        <div class="wenhaoIconWrap">
          <img class="wenhaoIcon" src="../../../assets/wenhaoIcon.png" alt="">
          <div class="whBubble">
            <img class="home_pic_triangle_d" src="../../../assets/home_pic_triangle_d.png" alt="">
            <div class="bubbleTit">睡眠得分反映的是使用者整晚睡眠的综合情况，分数越高，综合感受越好。</div>
            <div class="bubbleTipWrap">
              <img class="bubbleTip_upImg" src="../../../assets/soIcon_up_green.png" alt="">
              <div class="bubbleTip ml5">上升代表有提升</div>
              <img class="bubbleTip_upImg" style="margin-left:28px;" src="../../../assets/soIcon_down_red.png" alt="">
              <div class="bubbleTip ml5">下降代表需要关注</div>
            </div>
          </div>
        </div>
       
        <div class="rListTopTit2">昨天</div>
      </div>
      <!-- 有数据情况 -->
      <div class="rListBot" v-if="new_rankList.resultReason && new_rankList.resultReason.fallReason == 0">
        <div class="rListBot_list rListBot_list_topBox">
          <div class="num">排名</div>
          <div class="bedName">床位</div>
          <div class="score">得分</div>
        </div>
        <div :key="index" v-for="(item,index) in new_rankList.sleepTop" @click="details(item.bedId,item.bedName,item.sn)">
          <div class="rListBot_list" v-if="index < 8">
            <div class="num">{{index+1 }}</div>
            <div class="bedName">{{ item.bedName }}</div>
            <div class="score">{{item.score}}</div>
            <img class="soIcon" src="../../../assets/soIcon_up_green.png" alt="" v-if="item.isRise == 1">
            <!-- <img class="soIcon" src="../../../assets/soIcon_down_green.png" alt=""> -->
            <!-- <img class="soIcon" src="../../../assets/soIcon_up_red.png" alt=""> -->
            <img class="soIcon" src="../../../assets/soIcon_down_red.png" alt="" v-if="item.isRise == -1">
            <div class="soIcon_gang" v-if="item.isRise == 0"></div>
          </div>
        </div>
        
      </div>
      <!-- 无数据情况 -->
      <div class="rListBot noData" v-if="new_rankList.resultReason && new_rankList.resultReason.fallReason != 0">
        <div class="">睡眠设备赶紧用起来才能看到更多内容哦</div>
      </div>
    </div>
    <!-- 跌倒风险排行榜 -->
    <div class="rankList">
      <div class="rListTop">
        <div class="rListTopTit">跌倒风险排行榜</div>
        <div class="wenhaoIconWrap">
          <img class="wenhaoIcon" src="../../../assets/wenhaoIcon.png" alt="">
          <div class="whBubble whBubble_dd">
            <img class="home_pic_triangle_d" src="../../../assets/home_pic_triangle_d.png" alt="">
            <div class="bubbleTit">跌倒风险反映的是使用者跌倒的可能性，分数越高，跌倒的风险越高（参考值≤50）</div>
            <div class="bubbleTipWrap">
              <div class="bubbleTip">*当跌倒风险指数大于50的时候，建议您关注一下长者的情况</div>
            </div>
            <div class="bubbleTipWrap">
              <img class="bubbleTip_upImg" src="../../../assets/soIcon_up_red.png" alt="">
              <div class="bubbleTip ml5">上升代表需要关注</div>
              <img class="bubbleTip_upImg" style="margin-left:28px;" src="../../../assets/soIcon_down_green.png" alt="">
              <div class="bubbleTip ml5">下降代表有好转</div>
            </div>
          </div>
        </div>
        <div class="rListTopTit2">昨天</div>
      </div>
      <!-- 有数据情况 -->
      <div class="rListBot" v-if="new_rankList.resultReason && new_rankList.resultReason.fallReason == 0">
        <div class="rListBot_list rListBot_list_topBox">
          <div class="num">排名</div>
          <div class="bedName">床位</div>
          <div class="score">指数</div>
        </div>
        <div :key="index" v-for="(item,index) in new_rankList.fallTop" @click="details(item.bedId,item.bedName,item.sn)">
          <div class="rListBot_list" v-if="index < 8">
            <div class="num">{{index+1 }}</div>
            <div class="bedName">{{ item.bedName }}</div>
            <div class="score">{{item.fallIndex}}</div>
            <!-- <img class="soIcon" src="../../../assets/soIcon_up_green.png" alt=""> -->
            <img class="soIcon" src="../../../assets/soIcon_down_green.png" alt="" v-if="item.isRise == -1">
            <img class="soIcon" src="../../../assets/soIcon_up_red.png" alt="" v-if="item.isRise == 1">
            <!-- <img class="soIcon" src="../../../assets/soIcon_down_red.png" alt=""> -->
            <div class="soIcon_gang" v-if="item.isRise == 0"></div>
          </div>
        </div>
      </div>
      <!-- 无数据情况 -->
      <div class="rListBot noData" v-if="new_rankList.resultReason && new_rankList.resultReason.fallReason != 0">
        <div class="">睡眠设备赶紧用起来才能看到更多内容哦</div>
      </div>
    </div>
    <!-- 呼吸异常指数排行榜 -->
    <div class="rankList">
      <div class="rListTop">
        <div class="rListTopTit">呼吸异常指数排行榜</div>
        <div class="wenhaoIconWrap">
          <img class="wenhaoIcon" src="../../../assets/wenhaoIcon.png" alt="">
          <div class="whBubble whBubble_hxyc">
            <img class="home_pic_triangle_d" src="../../../assets/home_pic_triangle_d.png" alt="">
            <div class="bubbleTit">呼吸异常风险反映的是使用者呼吸潜在的异常风险</div>
            <div class="bubbleTipWrap">
              <div class="buPoint"></div>
              <div class="bubbleTip ml5">指数<5 是健康</div>
            </div>
            <div class="bubbleTipWrap">
              <div class="buPoint bgFFC471"></div>
              <div class="bubbleTip ml5">5≤指数<15 疑似低风险</div>
            </div>
            <div class="bubbleTipWrap">
              <div class="buPoint bgFFC471"></div>
              <div class="bubbleTip ml5">15≤指数<30 疑似中风险</div>
            </div>
            <div class="bubbleTipWrap">
              <div class="buPoint bgFF7186"></div>
              <div class="bubbleTip ml5">指数≥30 疑似高风险</div>
            </div>
            <div class="bubbleTipWrap">
              <img class="bubbleTip_upImg" src="../../../assets/soIcon_up_red.png" alt="">
              <div class="bubbleTip ml5">上升代表需要关注</div>
              <img class="bubbleTip_upImg" style="margin-left:28px;" src="../../../assets/soIcon_down_green.png" alt="">
              <div class="bubbleTip ml5">下降代表有好转</div>
            </div>
          </div>
        </div>
        <div class="rListTopTit2">昨天</div>
      </div>
      <!-- 有数据情况 -->
      <div class="rListBot" v-if="new_rankList.resultReason && new_rankList.resultReason.fallReason == 0">
        <div class="rListBot_list rListBot_list_topBox">
          <div class="num">排名</div>
          <div class="bedName">床位</div>
          <div class="score">指数</div>
        </div>
        <div :key="index" v-for="(item,index) in new_rankList.ahiTop" @click="details(item.bedId,item.bedName,item.sn)">
          <div class="rListBot_list" v-if="index < 8">
            <div class="num">{{index+1 }}</div>
            <div class="bedName">{{ item.bedName }}</div>
            <div class="score color4D8EF7" v-if="item.ahi < 5">{{item.ahi}}</div>
            <div class="score colorFFC471" v-if="item.ahi >= 5 && item.ahi <= 30">{{item.ahi}}</div>
            <div class="score colorFF7186" v-if="item.ahi > 30">{{item.ahi}}</div>
            <!-- <img class="soIcon" src="../../../assets/soIcon_up_green.png" alt=""> -->
            <img class="soIcon" src="../../../assets/soIcon_down_green.png" alt="" v-if="item.isRise == -1">
            <img class="soIcon" src="../../../assets/soIcon_up_red.png" alt="" v-if="item.isRise == 1">
            <!-- <img class="soIcon" src="../../../assets/soIcon_down_red.png" alt=""> -->
            <div class="soIcon_gang" v-if="item.isRise == 0"></div>
          </div>
        </div>
        
      </div>
      <!-- 无数据情况 -->
      <div class="rListBot noData" v-if="new_rankList.resultReason && new_rankList.resultReason.fallReason != 0">
        <div class="">睡眠设备赶紧用起来才能看到更多内容哦</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    healthBigData: null,
    rankListData: null,
  },
  watch: {
    rankListData(newVal,oldVal){
      this.new_rankList = newVal
    }
  },
  data() {
    return {
      new_rankList: [],
      //rankData[rankList[item-1]][index]
      rankEmpty: false,
      rankData: {},
      titleList: [
        '睡眠得分排行榜',
        'AHI排行榜',
        '跌倒风险指数排行榜',
        '活力值排行榜',
        '情绪值排行榜',
      ],
      rankList: ['sleepTop', 'ahiTop', 'fallTop', 'vitalityTop', 'moraleTop'],
      scoreList: ['score', 'ahi', 'fallIndex', 'vitalityIndex', 'moraleIndex'],
      maxHeight: {},
      resultReasons: [false, false],
      getHours: null,
      timeStatus: false,
      activeDates: [],
    };
  },
  created() {},
  mounted() {
    //console.log(this.rankData);
    this.getActiveDates();
  },
  methods: {
    getActiveDates() {
      var day = new Date();
      var time = day.getTime();
      for (var i = 0; i <= 29; i++) {
        var ms = 24 * 3600 * 1000 * i;
        day.setTime(parseInt(time - ms));
        var y = day.getFullYear().toString();
        var m = (day.getMonth() + 1).toString();
        if (m.length <= 1) m = '0' + m;
        var d = day.getDate().toString();
        if (d.length <= 1) d = '0' + d;
        this.activeDates[i] = y + '-' + m + '-' + d;
      }
      //console.log(this.activeDates);
    },
    details(bedId, bedName, sn) {
      var scope = {
        bedId: bedId,
        bedName: bedName,
        activeType: 1,
        activeDate: this.activeDates[0],
        sn: sn,
      };
      this.$parent.details(scope);
    },
  },
};
</script>
<style lang="scss" scoped>
.rank {
  width: 100%;
  margin-top: 10px;
  display: flex;
  .rankList:nth-of-type(1){
    margin-left: 0;
  }
  .rankList{
    width: 393px;
    height: 452px;
    background: #FFFFFF;
    border-radius: 10px;
    padding: 20px;
    box-sizing: border-box;
    margin-left: 10px;
    .rListTop{
      width: 100%;
      display: flex;
      align-items: center;
      .rListTopTit{
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #1F2635;
        position:relative
      }
      .rListTopTit::after{
        width: 4px;
        height: 20px;
        background: #1890FF;
        border-radius: 0px 2px 2px 0px;
        content: '';
        position: absolute;
        left: -20px;
        top: 3px;
      }
      .wenhaoIconWrap:hover .whBubble{
        display: block;
      }
      .wenhaoIconWrap{
        width: 20px;
        height: 20px;
        margin-left: 5px;
        cursor: pointer;
        position: relative;
        .wenhaoIcon{
          width: 100%;
          height: 100%;
          display: block;
        }
        .whBubble{
          width: 375px;
          height: 128px;
          background: #FFFFFF;
          box-shadow: 0px 3px 5px 0px rgba(0,0,0,0.2);
          border-radius: 8px;
          padding: 20px;
          box-sizing: border-box;

          position: absolute;
          top: -140px;
          left: -178px;
          z-index: 999;
          display: none;
          .home_pic_triangle_d{
            width: 16px;
            height: 11px;
            display: block;
            position: absolute;
            left: 50%;
            bottom: -11px;
            transform: translateX(-50%);
          }
        
          .bubbleTit{
            width: 335px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #1F2635;
            line-height: 24px;
            position: relative;
          }
          .bubbleTit::after{
            width: 3px;
            height: 18px;
            content: '';
            background: #4D8EF7;
            border-radius: 2px;
            
            position: absolute; 
            left: -20px; 
            top: 3px; 
          }
          .bubbleTipWrap{
            margin-top: 10px;
            display: flex;
            align-items: center;
            .bubbleTip_upImg{
              width: 9px;
              height: 12px;
              display: block;
            }
            .bubbleTip{
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #5E6779;
            }
            .buPoint{
              width: 8px;
              height: 8px;
              background: #4D8EF7;
              border-radius: 50%;
            }
          }
        }
        .whBubble_dd{
          height: 184px;
          top: -196px;
        }
        .whBubble_hxyc{
          height: 264px;
          top: -276px;
        }

      }
      .rListTopTit2{
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #CACDD9;
        margin-left: auto;
      }
    }
    .rListBot{
      width: 350px;
      height: 373px;
      background: #F7F8FA;
      border-radius: 4px;
      margin-top: 15px;
      .rListBot_list{
        width: 100%;
        height: 40px;
        border-top: 1px solid #ECEDF0;
        display: flex;
        align-items: center;
        cursor: pointer;
        .num{
          width: 50px;
          margin-left: 20px;
        }
        .bedName{
          width: 195px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .score{
          width: 30px;
          margin-left: 20px;
        }
        .soIcon{
          width: 9px;
          height: 12px;
          margin-left: 10px;
        }
        .soIcon_gang{
          width: 9px;
          height: 2px;
          background: #CACDD9;
          margin-left: 10px;
        }
      }
      .rListBot_list_topBox{
        height: 50px;
        border-top: 0;
        div{
          font-weight: bold;
        }
      }
    }
    .noData{
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #A5A9BC;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
